import Vue from 'vue'
import './cube-ui'
import './plugins/element'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './utils/interceptors'
import './permission'
import './rem'
import './boder.css'
import './reset.css'
import './quanju.css'
import store from './store/index'
import './registerServiceWorker'
import './assets/css/iconfont/iconfont.css'
import './assets/iconfont/iconfont.css'
import vant from './ui/vant'
import 'vant/lib/index.css';
import echarts from 'echarts'
import {get, post, fileUpload} from "./utils/http";
import VueCanvasPoster from 'vue-canvas-poster'
import "./assets/iconfont/iconfont.css";

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$fileUpload = fileUpload;
Vue.use(VueCanvasPoster)
Vue.use(vant);
window.$vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
